const Loading = () => {
  return (
    <div className="z-40 w-full flex justify-center items-center">
      <div className="border-[6px] border-solid border-zinc-200 rounded-full border-t-[8px] border-t-[#3F4A9C] w-14 h-14 animate-spin"></div>
    </div>
  );
}

export default Loading